"use client";
import React, { useState, useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import EmbeddedPointCard from "@/components/maps/embed/EmbeddedPointCard";
import MobileDrawer from "@/components/shared/MobileDrawerWrapper";

import "@/components/maps/embed/EmbeddedPointCardWrapper.css";

const EmbeddedPointCardWrapper = ({
  name,
  coordinates,
  showPointDetails,
  closeMarkerDetails,
  point,
  ownerId,
  contentId,
  external,
  community,
  backClick,
  forwardClick,
  parent,
  enableEdit
}) => {
  const isSm = useMediaQuery({ query: "(max-width: 767.98px)" });
  const [cardClass, setCardClass] = useState("hide");

  useEffect(() => {
    if (showPointDetails) {
      setCardClass(isSm ? "show" : "expand-card");
    } else {
      setCardClass("hide");
    }
  }, [showPointDetails]);

  function onClose() {
    setCardClass("hide");
    closeMarkerDetails();
  }

  const theDiv = (
    <div
      className={`
          embedded-point-card-wrapper
          ${cardClass}
        `}
    >
      <div className="header">
        {isSm && (
          <button type="button" className="clear" onClick={() => onClose()}>
            <span className="material-icons">expand_more</span>
          </button>
        )}
        <div className="flex-grow" />
        <button type="button" className="clear" onClick={backClick}>
          <span className="material-icons">arrow_back_ios</span>
        </button>
        <button type="button" className="clear" onClick={forwardClick}>
          <span className="material-icons">arrow_forward_ios</span>
        </button>
      </div>
      <EmbeddedPointCard
        name={name}
        point={point}
        community={community}
        coordinates={coordinates}
        ownerId={ownerId}
        contentId={contentId}
        external={external}
        enableEdit={enableEdit}
      />
    </div>
  );

  if (isSm) {
    return (
      <MobileDrawer
        open={showPointDetails}
        onRequestClose={onClose}
        modalElementClass="mobile-drawer-modal"
        containerElementClass="mobile-drawer-container"
        hideScrollbars={true}
        parentElement={parent}
      >
        {theDiv}
      </MobileDrawer>
    );
  }

  return theDiv;

};

export default EmbeddedPointCardWrapper;
